var map = {
	"./01.png": 112,
	"./02.png": 113,
	"./03.png": 114,
	"./04.png": 115,
	"./05.png": 116,
	"./06.png": 117,
	"./07.png": 118,
	"./08.png": 119,
	"./09.png": 120,
	"./10.png": 121,
	"./11.png": 122,
	"./12.png": 123,
	"./13.png": 124,
	"./14.png": 125,
	"./15.png": 126,
	"./16.png": 127,
	"./17.png": 128,
	"./18.png": 129,
	"./19.png": 130,
	"./20.png": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 927;